import { inject } from '@angular/core';
import { CanActivateFn, CanDeactivateFn, Router, UrlTree } from '@angular/router';
import { RoutingService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { CheckoutService } from '../services';

// проверяет что данные по заказу есть в сторе
export const orderConfirmationGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const checkoutService = inject(CheckoutService);
  const router = inject(Router);
  const routingService = inject(RoutingService);

  return checkoutService.getOrderDetails().pipe(
    take(1),
    map((order) => {
      if (order?.code) {
        return true;
      }

      return router.parseUrl(routingService.getUrl({ cxRoute: 'cart' }));
    }),
  );
};

// очищает состояние при уходе со страницы
export const clearOrderConfirmationGuard: CanDeactivateFn<unknown> = (): boolean => {
  const checkoutService = inject(CheckoutService);

  checkoutService.clearPlaceOrderState();

  return true;
};
